import { GetRedirectUrlResponse, SetRedirectUrlPayload } from '@oy/types';
import axios, { BUSINESS_PAYMENT_PREFIX } from 'src/clients/axios';

export function getRedirectUrl() {
  return axios.request<GetRedirectUrlResponse>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}/channel/get-redirect-config`,
  });
}

export function postSetRedirectUrl(data: SetRedirectUrlPayload) {
  return axios({
    method: 'post',
    url: `${BUSINESS_PAYMENT_PREFIX}/channel/set-redirect-config`,
    data,
  });
}
